import { render } from "./GoogleMeetIcon.vue?vue&type=template&id=de98791e"
import script from "./GoogleMeetIcon.vue?vue&type=script&lang=js"
export * from "./GoogleMeetIcon.vue?vue&type=script&lang=js"
script.render = render

export default script